import { css } from 'aphrodite';
import moment from 'moment';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '../../../../../components-v2/Button';
import { Label } from '../../../../../components-v2/Label';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../../components-v2/Select';
import { ShiftsTab } from '../../../../../pages/Volunteers/ShiftsTab';
import { ShiftDataSource } from '../../../../../pages/Volunteers/shiftDataSource';
import { EventRegistrationFormData } from '../../utils';
import { generateShiftsFromEventWindow } from './eventWindowShifts';
import { styleSheet } from './styles';

const SHIFT_LENGTH_OPTIONS = [
	{ value: '30', label: '30 min' },
	{ value: '60', label: '1 hour' },
	{ value: '90', label: '1 hour 30 min' },
	{ value: '120', label: '2 hours' },
] as const;

export const VolunteerShiftsSection = ({ dataSource }: { dataSource: ShiftDataSource }) => {
	const { getValues } = useFormContext<EventRegistrationFormData>();
	const [shiftLengthMinutes, setShiftLengthMinutes] = useState(60);

	const toDashDate = (slashDate?: string) =>
		slashDate ? moment(slashDate, 'YYYY/MM/DD').format('YYYY-MM-DD') : undefined;
	const activityDateRange = {
		start: toDashDate(getValues('startDate')),
		end: toDashDate(getValues('endDate')),
	};

	const handleGenerate = async () => {
		const { startDate, startTime, endDate, endTime, timezone } = getValues();
		const bodies = generateShiftsFromEventWindow({
			startDate,
			startTime,
			endDate,
			endTime,
			timezone,
			shiftLengthMinutes,
		});
		if (bodies.length) {
			await dataSource.createShifts(bodies);
		}
	};

	return (
		<div>
			<div className={css(styleSheet.shiftControls)}>
				<Label>Shift length</Label>
				<Select value={String(shiftLengthMinutes)} onValueChange={val => setShiftLengthMinutes(Number(val))}>
					<SelectTrigger>
						<span>{SHIFT_LENGTH_OPTIONS.find(opt => opt.value === String(shiftLengthMinutes))?.label}</span>
					</SelectTrigger>
					<SelectContent>
						{SHIFT_LENGTH_OPTIONS.map(opt => (
							<SelectItem key={opt.value} value={opt.value}>
								{opt.label}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
				<Button type='button' variant='outline' onClick={handleGenerate}>
					Generate shifts
				</Button>
			</div>
			<ShiftsTab
				dataSource={dataSource}
				activityTimeZone={getValues('timezone')}
				activityDateRange={activityDateRange}
				listStyles={[styleSheet.shiftListScroll]}
			/>
		</div>
	);
};
